import React from 'react';

const OpenMRSLogo = props => {
  return (
    <img src="./openmrs_logo_white.gif" {...props} />
  )
}

export default OpenMRSLogo;
